import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Container, Nav, Image } from 'react-bootstrap';
import { Telephone } from 'react-bootstrap-icons';
import logo from './images/logo.jpg';
import './NavBar.css';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleLinkClick = () => {
      setIsMenuOpen(false);
    };

    const menuLinks = document.querySelectorAll('.navbar-nav .nav-link');
    menuLinks.forEach((link) => {
      link.addEventListener('click', handleLinkClick);
    });

    return () => {
      menuLinks.forEach((link) => {
        link.removeEventListener('click', handleLinkClick);
      });
    };
  }, []);

  return (
    <Navbar id="Nav" bg="dark" expand="lg" variant="dark" sticky="top">
      <Container>
        <Navbar.Brand href="#top">
          <Image
            alt=""
            src={logo}
            width="60"
            height="60"
            className="d-inline-block align-center"
            rounded="true"
            style={{ marginLeft: '20px' }}
          />{' '}
          אליגמן פתרונות הנדסיים
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        />
        <Navbar.Collapse id="basic-navbar-nav" className={isMenuOpen ? '' : 'collapse'}>
          <Nav className="me-auto" dir="rtl">
            <Nav.Link href="#top">ראשי</Nav.Link>
            <Nav.Link href="#services">התמחויות</Nav.Link>
            <Nav.Link href="#works">עבודות</Nav.Link>
            <Nav.Link href="#contact">צרו קשר</Nav.Link>
            <Nav.Link href="tel:054-5995998">
              חייגו <Telephone />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
